import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
	state:{
		jishu:0
		
	},
	mutations:{
		jishu(a,b){
			a.jishu=b
		}

	}
})


// WEBPACK FOOTER //
// ./src/store/store.js